import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//成绩管理系统相关API

const scoreManageAdultEducation = {
    //成绩设置
    setting: {
        //默认设置
        defaultConfig: {
            query: config => createAPI('/scoreManageAdultEducation/setting/defaultConfig/query', 'post', config),

            save: config => createAPI('/scoreManageAdultEducation/setting/defaultConfig/save', 'post', config),
        },
        //登分时间设置
        time: {
            initCombo: config => createAPI('/scoreManageAdultEducation/setting/time/initCombo', 'post', config),

            queryList: config => createAPI('/scoreManageAdultEducation/setting/time/queryList', 'post', config),

            saveTime: config => createAPI('/scoreManageAdultEducation/setting/time/saveTime', 'post', config),

            saveBkTime: config => createAPI('/scoreManageAdultEducation/setting/time/saveBkTime', 'post', config),

            saveDbkTime: config => createAPI('/scoreManageAdultEducation/setting/time/saveDbkTime', 'post', config),
        },
        //科目设置
        subject: {
            queryList: config => createAPI('/scoreManageAdultEducation/setting/subject/queryList', 'post', config),

            initCombo: config => createAPI('/scoreManageAdultEducation/setting/subject/initCombo', 'post', config),

            updateSubjectInfo: config => createAPI('/scoreManageAdultEducation/setting/subject/updateSubjectInfo', 'post', config),

            scoreDefaultConfig: config => createAPI('/scoreManageAdultEducation/setting/subject/scoreDefaultConfig', 'post', config),

            loadDfConfig: config => createAPI('/scoreManageAdultEducation/setting/subject/loadDfConfig', 'post', config),

            saveScoreSet: config => createAPI('/scoreManageAdultEducation/setting/subject/saveScoreSet', 'post', config),

            importScoreConfig: config => createAPI('/scoreManageAdultEducation/setting/subject/importScoreConfig', 'post', config),

            loadCourseCombo: config => createAPI('/scoreManageAdultEducation/setting/subject/loadCourseCombo', 'post', config),

            loadClassTree: config => createAPI('/scoreManageAdultEducation/setting/subject/loadClassTree', 'post', config),

            saveScoreBatchSet: config => createAPI('/scoreManageAdultEducation/setting/subject/saveScoreBatchSet', 'post', config),
        },
        //登分人员设置
        person: {
            queryList: config => createAPI('/scoreManageAdultEducation/setting/person/queryList', 'post', config),

            initCombo: config => createAPI('/scoreManageAdultEducation/setting/person/initCombo', 'post', config),

            queryTeaList: config => createAPI('/scoreManageAdultEducation/setting/person/queryTeaList', 'post', config),

            queryTeaStuList: config => createAPI('/scoreManageAdultEducation/setting/person/queryTeaStuList', 'post', config),

            saveTea: config => createAPI('/scoreManageAdultEducation/setting/person/saveTea', 'post', config),

            queryStuList: config => createAPI('/scoreManageAdultEducation/setting/person/queryStuList', 'post', config),

            queryClassStuTree: config => createAPI('/scoreManageAdultEducation/setting/person/queryClassStuTree', 'post', config),

            saveAddStu: config => createAPI('/scoreManageAdultEducation/setting/person/saveAddStu', 'post', config),

            saveStu: config => createAPI('/scoreManageAdultEducation/setting/person/saveStu', 'post', config),

            queryDelStuList: config => createAPI('/scoreManageAdultEducation/setting/person/queryDelStuList', 'post', config),

            delStu: config => createAPI('/scoreManageAdultEducation/setting/person/delStu', 'post', config),

            queryClassCourseList: config => createAPI('/scoreManageAdultEducation/setting/person/queryClassCourseList', 'post', config),

            syncStuList: config => createAPI('/scoreManageAdultEducation/setting/person/syncStuList', 'post', config),

            saveTeaStu: config => createAPI('/scoreManageAdultEducation/setting/person/saveTeaStu', 'post', config),

            addStuScoreData: config => createAPI('/scoreManageAdultEducation/setting/person/addStuScoreData', 'post', config),

            queryTeaAuthList: config => createAPI('/scoreManageAdultEducation/setting/person/queryTeaAuthList', 'post', config),

            saveTeaAuth: config => createAPI('/scoreManageAdultEducation/setting/person/saveTeaAuth', 'post', config),

            delTeaAuth: config => createAPI('/scoreManageAdultEducation/setting/person/delTeaAuth', 'post', config),

            findTeaAuthClass: config => createAPI('/scoreManageAdultEducation/setting/person/findTeaAuthClass', 'post', config),
        },
        //补考教师设置
        resitTeacher: {
            initCombo: config => createAPI('/scoreManageAdultEducation/setting/resitTeacher/initCombo', 'post', config),

            queryList: config => createAPI('/scoreManageAdultEducation/setting/resitTeacher/queryList', 'post', config),

            queryTeaList: config => createAPI('/scoreManageAdultEducation/setting/resitTeacher/queryTeaList', 'post', config),

            saveTea: config => createAPI('/scoreManageAdultEducation/setting/resitTeacher/saveTea', 'post', config),

            initBkCourseInfo: config => createAPI('/scoreManageAdultEducation/setting/resitTeacher/initBkCourseInfo ', 'post', config),
        },
        //大补考教师设置
        finalResitTeacher: {
            queryList: config => createAPI('/scoreManageAdultEducation/setting/finalResitTeacher/queryList', 'post', config),

            initData: config => createAPI('/scoreManageAdultEducation/setting/finalResitTeacher/initData', 'post', config),

            queryTeaList: config => createAPI('/scoreManageAdultEducation/setting/finalResitTeacher/queryTeaList', 'post', config),

            saveTea: config => createAPI('/scoreManageAdultEducation/setting/finalResitTeacher/saveTea', 'post', config),
        },
        //免修设置
        exemptStudy: {
            queryList: config => createAPI('/scoreManageAdultEducation/setting/exemptStudy/queryList', 'post', config),

            loadCourseCombo: config => createAPI('/scoreManageAdultEducation/setting/exemptStudy/loadCourseCombo', 'post', config),

            loadStuMxmd: config => createAPI('/scoreManageAdultEducation/setting/exemptStudy/loadStuMxmd', 'post', config),

            queStuList: config => createAPI('/scoreManageAdultEducation/setting/exemptStudy/queStuList', 'post', config),

            saveMxStu: config => createAPI('/scoreManageAdultEducation/setting/exemptStudy/saveMxStu', 'post', config),

            loadStuCourseListData: config => createAPI('/scoreManageAdultEducation/setting/exemptStudy/loadStuCourseListData', 'post', config),

            saveStuMxCourse: config => createAPI('/scoreManageAdultEducation/setting/exemptStudy/saveStuMxCourse', 'post', config),

            initCombo: config => createAPI('/scoreManageAdultEducation/setting/exemptStudy/initCombo', 'post', config),
        },
        //缓考成绩设置
        delay: {
            initCombo: config => createAPI('/scoreManageAdultEducation/setting/delay/initCombo', 'post', config),

            queryList: config => createAPI('/scoreManageAdultEducation/setting/delay/queryList', 'post', config),

            loadCourseCombo: config => createAPI('/scoreManageAdultEducation/setting/delay/loadCourseCombo', 'post', config),

            loadStuCourseListData: config => createAPI('/scoreManageAdultEducation/setting/delay/loadStuCourseListData', 'post', config),

            loadStuHkmd: config => createAPI('/scoreManageAdultEducation/setting/delay/loadStuHkmd', 'post', config),

            queStuList: config => createAPI('/scoreManageAdultEducation/setting/delay/queStuList', 'post', config),

            saveHkStu: config => createAPI('/scoreManageAdultEducation/setting/delay/saveHkStu', 'post', config),

            saveStuHkCourse: config => createAPI('/scoreManageAdultEducation/setting/delay/saveStuHkCourse', 'post', config),
        }
    },

    //成绩查询与统计
    query: {
        //整班成绩查询
        classScoreInfo: {
            queryList: config => createAPI('/scoreManageAdultEducation/query/classScoreInfo/queryList', 'post', config),

            initData: config => createAPI('/scoreManageAdultEducation/query/classScoreInfo/initData', 'post', config),

            initStuScoreInfo: config => createAPI('/scoreManageAdultEducation/query/classScoreInfo/initStuScoreInfo', 'post', config),

            exportScoreInfo: config => createAPI('/scoreManageAdultEducation/query/classScoreInfo/exportScoreInfo', 'post', config),

            batchExport: config => createAPI('/scoreManageAdultEducation/query/classScoreInfo/batchExport', 'post', config),
        },
        //学年学期成绩查询
        semesterScore: {
            queryList: config => createAPI('/scoreManageAdultEducation/query/semesterScore/queryList', 'post', config),

            initData: config => createAPI('/scoreManageAdultEducation/query/semesterScore/initData', 'post', config),

            saveSet: config => createAPI('/scoreManageAdultEducation/query/semesterScore/saveSet', 'post', config),

            loadStuScoreInfo: config => createAPI('/scoreManageAdultEducation/query/semesterScore/loadStuScoreInfo', 'post', config),

            exportScoreInfo: config => createAPI('/scoreManageAdultEducation/query/semesterScore/exportScoreInfo', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManageAdultEducation/query/semesterScore/loadExportClassCombo', 'post', config),

            batchExport: config => createAPI('/scoreManageAdultEducation/query/semesterScore/batchExport', 'post', config),

            batchScoreExport: config => createAPI('/scoreManageAdultEducation/query/semesterScore/batchScoreExport', 'post', config),

            batchWarnExport: config => createAPI('/scoreManageAdultEducation/query/semesterScore/batchWarnExport', 'post', config),

            initExCombo: config => createAPI('/scoreManageAdultEducation/query/semesterScore/initExCombo', 'post', config),
        },
        //不合格科目查询
        failSubject: {
            queryList: config => createAPI('/scoreManageAdultEducation/query/failSubject/queryList', 'post', config),

            initData: config => createAPI('/scoreManageAdultEducation/query/failSubject/initData', 'post', config),

            queryExamineList: config => createAPI('/scoreManageAdultEducation/query/failSubject/queryExamineList', 'post', config),

            exportSingle: config => createAPI('/scoreManageAdultEducation/query/failSubject/exportSingle', 'post', config),

            exportBatch: config => createAPI('/scoreManageAdultEducation/query/failSubject/exportBatch', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManageAdultEducation/query/failSubject/loadExportClassCombo', 'post', config),

            loadExportMajorCombo: config => createAPI('/scoreManageAdultEducation/query/failSubject/loadExportMajorCombo', 'post', config),
        },
        //学生成绩单
        stuScoreList: {
            queryList: config => createAPI('/scoreManageAdultEducation/query/stuScoreList/queryList', 'post', config),

            initCombo: config => createAPI('/scoreManageAdultEducation/query/stuScoreList/initCombo', 'post', config),

            queryStuScoreInfo: config => createAPI('/scoreManageAdultEducation/query/stuScoreList/queryStuScoreInfo', 'post', config),

            exportSingle: config => createAPI('/scoreManageAdultEducation/query/stuScoreList/exportSingle', 'post', config),

            exportBatch: config => createAPI('/scoreManageAdultEducation/query/stuScoreList/exportBatch', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManageAdultEducation/query/stuScoreList/loadExportClassCombo', 'post', config),
        },
        //补考名单
        resitStuList: {
            queryList: config => createAPI('/scoreManageAdultEducation/query/resitStuList/queryList', 'post', config),

            initCombo: config => createAPI('/scoreManageAdultEducation/query/resitStuList/initCombo', 'post', config),

            loadStuScoreInfo: config => createAPI('/scoreManageAdultEducation/query/resitStuList/loadStuScoreInfo', 'post', config),

            singleExport: config => createAPI('/scoreManageAdultEducation/query/resitStuList/singleExport', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManageAdultEducation/query/resitStuList/loadExportClassCombo', 'post', config),

            batchExport: config => createAPI('/scoreManageAdultEducation/query/resitStuList/batchExport', 'post', config),

            classListExport: config => createAPI('/scoreManageAdultEducation/query/resitStuList/classListExport', 'post', config),
        },
        //留级名单
        repeatGradeStuList: {
            queryList: config => createAPI('/scoreManageAdultEducation/query/repeatGradeStuList/queryList', 'post', config),

            initCombo: config => createAPI('/scoreManageAdultEducation/query/repeatGradeStuList/initCombo', 'post', config),

            loadScoreInfo: config => createAPI('/scoreManageAdultEducation/query/repeatGradeStuList/loadScoreInfo', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManageAdultEducation/query/repeatGradeStuList/loadExportClassCombo', 'post', config),

            batchExport: config => createAPI('/scoreManageAdultEducation/query/repeatGradeStuList/batchExport', 'post', config),
        },
        //大补考名单
        finalResitStuList: {
            queryList: config => createAPI('/scoreManageAdultEducation/query/finalResitStuList/queryList', 'post', config),

            initData: config => createAPI('/scoreManageAdultEducation/query/finalResitStuList/initData', 'post', config),

            queryStuList: config => createAPI('/scoreManageAdultEducation/query/finalResitStuList/queryStuList', 'post', config),

            singleExport: config => createAPI('/scoreManageAdultEducation/query/finalResitStuList/singleExport', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManageAdultEducation/query/finalResitStuList/loadExportClassCombo', 'post', config),

            batchExport: config => createAPI('/scoreManageAdultEducation/query/finalResitStuList/batchExport', 'post', config),
        },
        //成绩排名
        scoreRank: {
            queryList: config => createAPI('/scoreManageAdultEducation/query/scoreRank/queryList', 'post', config),

            initCombo: config => createAPI('/scoreManageAdultEducation/query/scoreRank/initCombo', 'post', config),

            exportFile: config => createAPI('/scoreManageAdultEducation/query/scoreRank/exportFile', 'post', config),

            printFile: config => createAPI('/scoreManageAdultEducation/query/scoreRank/printFile', 'post', config),
        },
    },

    //特殊成绩申请
    specialScoreApply: {
        initCombo: config => createAPI('/scoreManageAdultEducation/specialScoreApply/initCombo', 'post', config),

        list: config => createAPI('/scoreManageAdultEducation/specialScoreApply/list', 'post', config),

        loadCourseCombo: config => createAPI('/scoreManageAdultEducation/specialScoreApply/loadCourseCombo', 'post', config),

        save: config => createAPI('/scoreManageAdultEducation/specialScoreApply/save', 'post', config),

        submit: config => createAPI('/scoreManageAdultEducation/specialScoreApply/submit', 'post', config),

        updateAuditState: config => createAPI('/scoreManageAdultEducation/specialScoreApply/updateAuditState', 'post', config),

        del: config => createAPI('/scoreManageAdultEducation/specialScoreApply/del', 'post', config),

        attachmentList: config => createAPI('/scoreManageAdultEducation/specialScoreApply/attachmentList', 'post', config),

        uploadMultiFile: config => createAPI('/scoreManageAdultEducation/specialScoreApply/uploadMultiFile', 'post', config),

        delFileById: config => createAPI('/scoreManageAdultEducation/specialScoreApply/delFileById', 'post', config),

        delFileByCode: config => createAPI('/scoreManageAdultEducation/specialScoreApply/delFileByCode', 'post', config),

        queryAuditFlow: config => createAPI('/scoreManageAdultEducation/specialScoreApply/queryAuditFlow', 'post', config),
    },

    //学生个人成绩查询
    stuPersonalScore: {
        initCombo: config => createAPI('/scoreManageAdultEducation/stuPersonalScore/initCombo', 'post', config),

        list: config => createAPI('/scoreManageAdultEducation/stuPersonalScore/list', 'post', config),
    },

    //毕业设计
    graduateDesign: {
        initCombo: config => createAPI('/scoreManageAdultEducation/graduateDesign/initCombo', 'post', config),

        list: config => createAPI('/scoreManageAdultEducation/graduateDesign/list', 'post', config),

        saveRec: config => createAPI('/scoreManageAdultEducation/graduateDesign/saveRec', 'post', config),

        delRec: config => createAPI('/scoreManageAdultEducation/graduateDesign/delRec', 'post', config),

        updateAuditState: config => createAPI('/scoreManageAdultEducation/graduateDesign/updateAuditState', 'post', config),

        attachmentList: config => createAPI('/scoreManageAdultEducation/graduateDesign/attachmentList', 'post', config),

        uploadMultiFile: config => createAPI('/scoreManageAdultEducation/graduateDesign/uploadMultiFile', 'post', config),

        delFile: config => createAPI('/scoreManageAdultEducation/graduateDesign/delFile', 'post', config),
    },
    //毕业设计
    graduateDesign2: {
        initCombo: config => createAPI('/scoreManageAdultEducation/GradeDesign/initCombo', 'post', config),

        list: config => createAPI('/scoreManageAdultEducation/GradeDesign/list', 'post', config),

        listTeacher: config => createAPI('/scoreManageAdultEducation/GradeDesign/listTeacher', 'post', config),

        saveTeacherRec: config => createAPI('/scoreManageAdultEducation/GradeDesign/saveTeacherRec', 'post', config),

        saveRec: config => createAPI('/scoreManageAdultEducation/GradeDesign/saveRec', 'post', config),

        queryRec: config => createAPI('/scoreManageAdultEducation/GradeDesign/queryRec', 'post', config),

        downloadRec: config => createAPI('/scoreManageAdultEducation/GradeDesign/downloadRec', 'post', config),

        queryOption: config => createAPI('/scoreManageAdultEducation/GradeDesign/queryOption', 'post', config),

        queryOption2: config => createAPI('/scoreManageAdultEducation/GradeDesign/queryOption2', 'post', config),

        saveOption: config => createAPI('/scoreManageAdultEducation/GradeDesign/saveOption', 'post', config),

        save: config => createAPI('/scoreManageAdultEducation/GradeDesign/save', 'post', config),
    },
    //竞赛设置
    competition: {

        initCombo: config => createAPI('/scoreManageAdultEducation/competition/initCombo', 'post', config),

        initRegistrationCombo: config => createAPI('/scoreManageAdultEducation/competition/initRegistrationCombo', 'post', config),

        save: config => createAPI('/scoreManageAdultEducation/competition/save', 'post', config),

        saveCompetitionRegistration: config => createAPI('/scoreManageAdultEducation/competition/saveCompetitionRegistration', 'post', config),

        deleteCompetitionRegistration: config => createAPI('/scoreManageAdultEducation/competition/deleteCompetitionRegistration', 'post', config),

        queryList: config => createAPI('/scoreManageAdultEducation/competition/queryList', 'post', config),

        queryListCompetitionRegistration: config => createAPI('/scoreManageAdultEducation/competition/CompetitionRegistration', 'post', config),

        exportCompetitionRegistration: config => createAPI('/scoreManageAdultEducation/competition/exportCompetitionRegistration', 'post', config),

        saveRec: config => createAPI('/scoreManageAdultEducation/competition/saveRec', 'post', config),

        queryRscList: config => createAPI('/scoreManageAdultEducation/competition/queryRscList', 'post', config),

        deletefile: config => createAPI('/scoreManageAdultEducation/competition/deletefile', 'post', config),

    },
    //教学成果
    achievement: {

        initCombo: config => createAPI('/scoreManageAdultEducation/achievement/initCombo', 'post', config),

        initRegistrationCombo: config => createAPI('/scoreManageAdultEducation/achievement/initRegistrationCombo', 'post', config),

        save: config => createAPI('/scoreManageAdultEducation/achievement/save', 'post', config),

        saveCompetitionRegistration: config => createAPI('/scoreManageAdultEducation/achievement/saveCompetitionRegistration', 'post', config),

        deleteAchievementRegistration: config => createAPI('/scoreManageAdultEducation/achievement/deleteAchievementRegistration', 'post', config),

        queryList: config => createAPI('/scoreManageAdultEducation/achievement/queryList', 'post', config),

        updateAchievement: config => createAPI('/scoreManageAdultEducation/achievement/updateAchievement', 'post', config),

        queryListAchievementRegistration: config => createAPI('/scoreManageAdultEducation/achievement/AchievementRegistration', 'post', config),

        exportCompetitionRegistration: config => createAPI('/scoreManageAdultEducation/achievement/exportCompetitionRegistration', 'post', config),

        saveRec: config => createAPI('/scoreManageAdultEducation/achievement/saveRec', 'post', config),

        queryRscList: config => createAPI('/scoreManageAdultEducation/achievement/queryRscList', 'post', config),

        deletefile: config => createAPI('/scoreManageAdultEducation/achievement/deletefile', 'post', config),


    },
    //重修
    retake: {
        initCombo: config => createAPI('/scoreManageAdultEducation/retake/initCombo', 'post', config),

        semesterList: config => createAPI('/scoreManageAdultEducation/retake/semesterList', 'post', config),

        saveDate: config => createAPI('/scoreManageAdultEducation/retake/saveDate', 'post', config),

        initStuListCombo: config => createAPI('/scoreManageAdultEducation/retake/initStuListCombo', 'post', config),

        studentList: config => createAPI('/scoreManageAdultEducation/retake/studentList', 'post', config),

        exportStudentRec: config => createAPI('/scoreManageAdultEducation/retake/exportStudentRec', 'post', config),

        courseList: config => createAPI('/scoreManageAdultEducation/retake/courseList', 'post', config),

        exportCourseRec: config => createAPI('/scoreManageAdultEducation/retake/exportCourseRec', 'post', config),

        queryApplySemester: config => createAPI('/scoreManageAdultEducation/retake/queryApplySemester', 'post', config),

        initApplyCombo: config => createAPI('/scoreManageAdultEducation/retake/initApplyCombo', 'post', config),

        applyList: config => createAPI('/scoreManageAdultEducation/retake/applyList', 'post', config),

        queryApplyCourseCombo: config => createAPI('/scoreManageAdultEducation/retake/queryApplyCourseCombo', 'post', config),

        apply: config => createAPI('/scoreManageAdultEducation/retake/apply', 'post', config),

        exemptApply: config => createAPI('/scoreManageAdultEducation/retake/exemptApply', 'post', config),

        initQueryCombo: config => createAPI('/scoreManageAdultEducation/retake/initQueryCombo', 'post', config),

        studentRetakeList: config => createAPI('/scoreManageAdultEducation/retake/studentRetakeList', 'post', config),

        exportStudentRetakeRec: config => createAPI('/scoreManageAdultEducation/retake/exportStudentRetakeRec', 'post', config),

        checkApplyOpenState: config => createAPI('/scoreManageAdultEducation/retake/checkApplyOpenState', 'post', config),

        delApply: config => createAPI('/scoreManageAdultEducation/retake/delApply', 'post', config),

        stuRepairSettingList: config => createAPI('/scoreManageAdultEducation/retake/stuRepairSettingList', 'post', config),

        handleStuRepairSetting: config => createAPI('/scoreManageAdultEducation/retake/handleStuRepairSetting', 'post', config),
    },

    //历史成绩查询
    historyScoreQuery: {
        initCombo: config => createAPI('/scoreManageAdultEducation/historyScore/initCombo', 'post', config),

        scoreList: config => createAPI('/scoreManageAdultEducation/historyScore/scoreList', 'post', config),
    },

    //统计
    statistics: {
        //成绩登记表
        subjectScoreReport: {
            query: config => createAPI('/scoreManageAdultEducation/statistics/subjectScoreReport/query', 'post', config),

            export: config => createAPI('/scoreManageAdultEducation/statistics/subjectScoreReport/export', 'post', config),

            print: config => createAPI('/scoreManageAdultEducation/statistics/subjectScoreReport/print', 'post', config),
        },

        //试卷质量分析报告
        examQualityAnalysis: {
            initCombo: config => createAPI('/scoreManageAdultEducation/statistics/examQualityAnalysis/initCombo', 'post', config),

            list: config => createAPI('/scoreManageAdultEducation/statistics/examQualityAnalysis/list', 'post', config),

            query: config => createAPI('/scoreManageAdultEducation/statistics/examQualityAnalysis/query', 'post', config),

            export: config => createAPI('/scoreManageAdultEducation/statistics/examQualityAnalysis/export', 'post', config),

            print: config => createAPI('/scoreManageAdultEducation/statistics/examQualityAnalysis/print', 'post', config),

            save: config => createAPI('/scoreManageAdultEducation/statistics/examQualityAnalysis/save', 'post', config),
        },

        //绩点统计
        pointStatistics: {
            queryList: config => createAPI('/scoreManageAdultEducation/statistics/pointStatistics/queryList', 'post', config),

            initData: config => createAPI('/scoreManageAdultEducation/statistics/pointStatistics/initData', 'post', config),

            queryPointList: config => createAPI('/scoreManageAdultEducation/statistics/pointStatistics/queryPointList', 'post', config),

            exportFile: config => createAPI('/scoreManageAdultEducation/statistics/pointStatistics/exportFile', 'post', config),

            printFile: config => createAPI('/scoreManageAdultEducation/statistics/pointStatistics/printFile', 'post', config),
        },

        //学期成绩统计
        semesterScoreStatistics: {
            queryList: config => createAPI('/scoreManageAdultEducation/statistics/semesterScoreStatistics/queryList', 'post', config),

            initData: config => createAPI('/scoreManageAdultEducation/statistics/semesterScoreStatistics/initData', 'post', config),

            loadStatisticsInfo: config => createAPI('/scoreManageAdultEducation/statistics/semesterScoreStatistics/loadStatisticsInfo', 'post', config),

            exportFile: config => createAPI('/scoreManageAdultEducation/statistics/semesterScoreStatistics/exportFile', 'post', config),

            batchExport: config => createAPI('/scoreManageAdultEducation/statistics/semesterScoreStatistics/batchExport', 'post', config),

            loadBatchExportClassCombo: config => createAPI('/scoreManageAdultEducation/statistics/semesterScoreStatistics/loadBatchExportClassCombo ', 'post', config),
        },
    },

    //登记
    register: {
        //班级学期成绩登记
        classSemesterScore: {
            initData: config => createAPI('/scoreManageAdultEducation/register/classSemesterScore/initData', 'post', config),

            loadMajorCombo: config => createAPI('/scoreManageAdultEducation/register/classSemesterScore/loadMajorCombo', 'post', config),

            loadClassCombo: config => createAPI('/scoreManageAdultEducation/register/classSemesterScore/loadClassCombo', 'post', config),

            queryList: config => createAPI('/scoreManageAdultEducation/register/classSemesterScore/queryList', 'post', config),

            loadClassCourseInfo: config => createAPI('/scoreManageAdultEducation/register/classSemesterScore/loadClassCourseInfo', 'post', config),

            loadDfConfig: config => createAPI('/scoreManageAdultEducation/register/classSemesterScore/loadDfConfig', 'post', config),

            loadScoreConvertConfig: config => createAPI('/scoreManageAdultEducation/register/classSemesterScore/loadScoreConvertConfig', 'post', config),

            loadStuList: config => createAPI('/scoreManageAdultEducation/register/classSemesterScore/loadStuList', 'post', config),

            loadLockState: config => createAPI('/scoreManageAdultEducation/register/classSemesterScore/loadLockState', 'post', config),

            saveScoreSet: config => createAPI('/scoreManageAdultEducation/register/classSemesterScore/saveScoreSet', 'post', config),

            saveStuScore: config => createAPI('/scoreManageAdultEducation/register/classSemesterScore/saveStuScore', 'post', config),

            submitStuScore: config => createAPI('/scoreManageAdultEducation/register/classSemesterScore/submitStuScore', 'post', config),

            exportFile: config => createAPI('/scoreManageAdultEducation/register/classSemesterScore/exportFile', 'post', config),

            importFile: config => createAPI('/scoreManageAdultEducation/register/classSemesterScore/importFile', 'post', config),

            loadExemptStuList: config => createAPI('/scoreManageAdultEducation/register/classSemesterScore/loadExemptStuList', 'post', config),

            updateExemptStuScore: config => createAPI('/scoreManageAdultEducation/register/classSemesterScore/updateExemptStuScore', 'post', config),

            loadClassMessage: config => createAPI('/scoreManageAdultEducation/register/classSemesterScore/loadClassMessage', 'post', config),
        },
        //缓考成绩登记
        delayScore: {
            initData: config => createAPI('/scoreManageAdultEducation/register/delayScore/initData', 'post', config),

            queryList: config => createAPI('/scoreManageAdultEducation/register/delayScore/queryList', 'post', config),

            loadClassCourseTreeByScoreType: config => createAPI('/scoreManageAdultEducation/register/delayScore/loadClassCourseTreeByScoreType', 'post', config),

            loadDfConfig: config => createAPI('/scoreManageAdultEducation/register/delayScore/loadDfConfig', 'post', config),

            loadStuListByScoreType: config => createAPI('/scoreManageAdultEducation/register/delayScore/loadStuListByScoreType', 'post', config),

            loadLockState: config => createAPI('/scoreManageAdultEducation/register/delayScore/loadLockState', 'post', config),

            saveStuScore: config => createAPI('/scoreManageAdultEducation/register/delayScore/saveStuScore', 'post', config),

            queryDelayScoreRecordList: config => createAPI('/scoreManageAdultEducation/register/delayScore/queryDelayScoreRecordList', 'post', config),

            exportDelayScoreRecord: config => createAPI('/scoreManageAdultEducation/register/delayScore/exportDelayScoreRecord', 'post', config),

            initReportData: config => createAPI('/scoreManageAdultEducation/register/delayScore/initReportData', 'post', config),

            loadCourseCombo: config => createAPI('/scoreManageAdultEducation/register/delayScore/loadCourseCombo', 'post', config),

            queryReportInfo: config => createAPI('/scoreManageAdultEducation/register/delayScore/queryReportInfo', 'post', config),

            exportReportInfo: config => createAPI('/scoreManageAdultEducation/register/delayScore/exportReportInfo', 'post', config),

            printReportInfo: config => createAPI('/scoreManageAdultEducation/register/delayScore/printReportInfo', 'post', config),
        },
        //补考成绩登记
        resitScore: {
            initData: config => createAPI('/scoreManageAdultEducation/register/resitScore/initData', 'post', config),

            queryList: config => createAPI('/scoreManageAdultEducation/register/resitScore/queryList', 'post', config),

            loadSubjectInfo: config => createAPI('/scoreManageAdultEducation/register/resitScore/loadSubjectInfo', 'post', config),

            loadStuList: config => createAPI('/scoreManageAdultEducation/register/resitScore/loadStuList', 'post', config),

            saveStuScore: config => createAPI('/scoreManageAdultEducation/register/resitScore/saveStuScore', 'post', config),

            reportExport: config => createAPI('/scoreManageAdultEducation/register/resitScore/reportExport', 'post', config),

            reportPrint: config => createAPI('/scoreManageAdultEducation/register/resitScore/reportPrint', 'post', config),
        },
        //教师成绩登记
        teacherSemesterScore: {
            initData: config => createAPI('/scoreManageAdultEducation/register/teacherSemesterScore/initData', 'post', config),

            queryList: config => createAPI('/scoreManageAdultEducation/register/teacherSemesterScore/queryList', 'post', config),

            loadClassInfo: config => createAPI('/scoreManageAdultEducation/register/teacherSemesterScore/loadClassInfo', 'post', config),
        },
        //大补考成绩登记
        finalResitScore: {
            initData: config => createAPI('/scoreManageAdultEducation/register/finalResitScore/initData', 'post', config),

            queryList: config => createAPI('/scoreManageAdultEducation/register/finalResitScore/queryList', 'post', config),

            loadStuList: config => createAPI('/scoreManageAdultEducation/register/finalResitScore/loadStuList', 'post', config),

            saveStuScore: config => createAPI('/scoreManageAdultEducation/register/finalResitScore/saveStuScore', 'post', config),
        },
        //成绩管理
        scoreManage: {
            initData: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/initData', 'post', config),

            queryList: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/queryList', 'post', config),

            saveScore: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/saveScore', 'post', config),

            changeStuScoreState: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/changeStuScoreState', 'post', config),

            queryInvalidScoreList: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/queryInvalidScoreList', 'post', config),

            recoveryScore: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/recoveryScore', 'post', config),

            loadChangeClassScoreClass: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/loadChangeClassScoreClass', 'post', config),

            loadChangeClassScoreCourse: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/loadChangeClassScoreCourse', 'post', config),

            queryChangeClassScoreList: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/queryChangeClassScoreList', 'post', config),

            changeMultiStuScoreState: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/changeMultiStuScoreState', 'post', config),

            queryClassNotRegisterList: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/queryClassNotRegisterList', 'post', config),

            loadExportMajorCombo: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/loadExportMajorCombo', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/loadExportClassCombo', 'post', config),

            scoreExport: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/scoreExport', 'post', config),

            batchExport: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/batchExport', 'post', config),

            collectExport: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/collectExport', 'post', config),

            queryStuNotRegisterList: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/queryStuNotRegisterList', 'post', config),

            stuNotRegisterExport: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/stuNotRegisterExport', 'post', config),

            exportClassNotRegisterList: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/exportClassNotRegisterList', 'post', config),

            queryScoreCompletionList: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/queryScoreCompletionList', 'post', config),

            completeScore: config => createAPI('/scoreManageAdultEducation/register/scoreManageAdultEducation/completeScore', 'post', config),
        },
        //成绩提交管理
        submitManage: {
            queryList: config => createAPI('/scoreManageAdultEducation/register/submitManage/queryList', 'post', config),

            sendBack: config => createAPI('/scoreManageAdultEducation/register/submitManage/sendBack', 'post', config),

            batchExport: config => createAPI('/scoreManageAdultEducation/register/submitManage/batchExport', 'post', config),
        },
        //结转毕补考成绩登记
        convertResitScore: {
            initCombo: config => createAPI('/scoreManageAdultEducation/register/convertResitScore/initCombo', 'post', config),

            list: config => createAPI('/scoreManageAdultEducation/register/convertResitScore/list', 'post', config),

            save: config => createAPI('/scoreManageAdultEducation/register/convertResitScore/save', 'post', config),
        },
    },
};

export default scoreManageAdultEducation;



// WEBPACK FOOTER //
// ./src/api/modules/scoreManageAdultEducation.js